import request from '@/service/request'

export const getActivity = (params: COMMON.API.QueryParams) => {
  return request<SERVICE.ResponsePage<CODE.Detail[]>>({
    url: '/admin/activity/page',
    method: 'GET',
    params
  })
}

export const addActivity = (data: ACTIVITY.Detail) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/activity',
    method: 'POST',
    data
  })
}

export const updateActivity = (data: ACTIVITY.Detail) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/activity',
    method: 'PUT',
    data
  })
}

export const delActivity = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/activity/' + id,
    method: 'DELETE'
  })
}

export const getActivityById = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/activity/' + id,
    method: 'GET'
  })
}

export const updateActivityStatus = (params: {activityId: number, status: 0 | 1}) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/activity/status',
    method: 'PUT',
    params
  })
}
